<template>
    <div class="text-center cursor-pointer" @click="openClub()">
        <vs-avatar :size="windowWidth >= 986 ? '82px' : '64px'" v-if="item.club_logo.path" :src="item.club_logo.path" class="mx-0 my-0"/>
        <vs-avatar :size="windowWidth >= 986 ? '82px' : '64px'" v-else class="mx-0 my-0" :text="logoText"/>
        <div class="truncate text-xs lg:text-sm">{{item.name}}</div>
    </div>
</template>

<script>
import {avatarText} from './utils'

export default {
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    methods: {
        openClub() {
            this.$router.push({
                name: "stud-clubs-main",
                query: { uid: this.item.uid }
            })
        }
    },
    computed: {
        windowWidth () { return this.$store.state.windowWidth },
        logoText() {
            return avatarText(this.item.name)
        }
    }
}
</script>
